import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Outlet, useLocation, useOutletContext, useParams } from 'react-router-dom';

import { UseOutletContext } from '../Main';
import { StateLanguage } from '../../../languages/config/StateLanguage';
import { DesignDA } from "../../../services/admin/design.service";
import { Error } from '../../../models/error.model';
import { AppService } from '../../../models/app.service.model';
import { Company } from '../../../models/company.model';
import { GlobalSwal } from '../../../styles/swal.style';
import { CompanySettings } from "../../../models/settings.model";
import { Design } from "../../../models/settings.designs.model";
import { ApiDigitalAuthCompany } from '../../../services/auth/company.service';
import { uploadTooltip } from '../../../utils/tooltip.util';
import { modalShow } from '../../../utils/modal.util';
import { imageCompany } from '../../../scripts/image.value.script';
import { getError } from '../../../languages/translations/response';
import { formatAddress } from '../../../scripts/format.value.script';
import { errorWebHandler } from '../../../scripts/error.web.handler.script';
import { useSubscription } from '../../../contexts/SubscriptionContext';

import AppModalCompanyUsers from '../../../components/modal/ModalCompanyUsers';
import UuidBadge from '../../../components/element/UuidBadge';
import AppModalUuidQr from '../../../components/modal/ModalUuidQr';


export interface CompanyPageProps {};

type ContexType = {
    setRoute: Dispatch<SetStateAction<{ path: { root: string; branch: string } | null; company: boolean } | null>>;
    appServiceForUser: AppService | null;
    company: Company | null;
    companyForUser: Company | null;
    settingsForCompany: CompanySettings | null;
    designs: Design[] | null;
    reloadSession: Function;
    loadCompanyForUser: Function;
};

let errorResponse: Error, companyResponse: Company, settingsResponse: CompanySettings, designResponse: any;

const CompanyPage: React.FunctionComponent<CompanyPageProps> = props => {
  const { setRoute, appServiceForUser, companyForUser, settingsForCompany, reloadSession, loadCompanyForUser } = UseOutletContext();
  const {lang} = StateLanguage()
  const location = useLocation()
  const { can: canSub } = useSubscription()
  const param = useParams()

  const [idCompany, setIdCompany] = useState('none')
  const [quantityUsers, setQuantityUsers] = useState(0)
  const [designs, setDesigns] = useState<Design[]>([]);
  const [company, setCompany] = useState<Company | null>(null)

  const loadCompany = async (api_key: string, id_company: string) => {
    await ApiDigitalAuthCompany.getCompany(api_key, id_company).then( (response) => {
      if (response.status === 200) {
        companyResponse = response.data
        setCompany(companyResponse)
      } else {
        errorResponse = response.data

        GlobalSwal.fire({
          title: getError(errorResponse.code, lang.code, errorResponse.message),
          text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
          icon: 'error',
          confirmButtonText: lang.labels.okGotIt
        })
      }
    }).catch( (error) => {
      errorWebHandler(lang, error)
    }) 
  }

  const loadTemplates = async (id_company: string) => {
      await DesignDA.getDesigns(id_company)
          .then((response) => {
              if (response.status === 200) {
                  designResponse = response.data;
                  setDesigns(designResponse.data ?? []);
              } else {
                  errorResponse = response.data;

                  GlobalSwal.fire({
                      title: getError(errorResponse.code, lang.code, errorResponse.message),
                      text: lang.labels.sorryLooksLikeThereAreSomeErrorstryAgain,
                      icon: "error",
                      confirmButtonText: lang.labels.okGotIt,
                  });
              }
          })
          .catch((error) => {
              errorWebHandler(lang, error);
          });
  };


  const executeShowModalCompanyView = () => {
    modalShow('modal-company-view')
  }

  function viewCardCompany(): boolean {
    let segments: string[] = location.pathname.split('/')

    if (param.language && segments[2] === 'main' && segments[3] === 'company' && ['view', 'update'].includes(segments[4])) {
      return true
    } else if (segments[1] === 'main' && segments[2] === 'company' && ['view', 'update'].includes(segments[3])) {
      return true
    } else {
      return false
    }
  }

  function viewNavigationCardCompany(): boolean {
    if (param.language && `/${location.pathname.split('/').slice(2).join('/')}` === '/main/company/update') {
      return true
    } else if (location.pathname === '/main/company/update') {
      return true
    } else {
      return false
    }
  }

  useEffect( () => {
    if (appServiceForUser && companyForUser && companyForUser.id !== idCompany) {
      setIdCompany(companyForUser.id)
      setQuantityUsers(0)
      setDesigns([]);

      /* const totalUsers: number = (companyForUser && companyForUser.users) ? companyForUser.users.length : 0 */

      /* const intervalUsers = setInterval(() => {
        setQuantityUsers((prevCount) => {
          if (prevCount >= totalUsers) {
            clearInterval(intervalUsers)
            return prevCount
          }
          return prevCount + 1
        })
      }, 100) */

      loadCompany(appServiceForUser.api_key, companyForUser.id)
      loadTemplates(companyForUser.id);

      uploadTooltip()

      /* return () => {
        clearInterval(intervalUsers)
      } */
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companyForUser])

  return (
      <div className="w-100 h-100">
          {company && viewCardCompany() && (
              <div className="card mb-5">
                  <div className="card-body pb-0">
                      <div className="d-flex flex-wrap flex-sm-nowrap mb-2">
                          <div className="me-5 mb-2">
                              <div className="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px">
                                  <img
                                      src={imageCompany(company.logo)}
                                      alt={lang.labels.logo}
                                      className="mw-75px mh-75px mw-lg-125px mh-lg-125px"
                                  />
                              </div>
                          </div>
                          <div className="flex-grow-1">
                              <div className="d-flex justify-content-between align-items-start flex-wrap mb-3">
                                  <div className="d-flex flex-column">
                                      <div className="d-flex align-items-center mb-1">
                                          <label className="fs-2 fw-bolder">{company.name}</label>
                                      </div>
                                      <div className="d-flex flex-wrap fw-bold text-muted fs-6 mb-2">
                                          {formatAddress(lang, company.address)}
                                      </div>
                                  </div>
                              </div>
                              <div className="d-flex flex-wrap justify-content-start mb-3">
                                  <div className="d-flex flex-wrap">
                                      <div className="border border-gray-300 border-dashed rounded min-w-125px py-2 px-3 me-5 mb-2">
                                          <div className="d-flex flex-wrap align-items-center">
                                              <div>
                                                  <UuidBadge uuid={company.uuid} label={company.name} />
                                                  <div className="fw-semibold text-muted">{lang.labels.uuidCompany}</div>
                                              </div>
                                          </div>
                                      </div>
                                      {/* <div className="border border-gray-300 border-dashed rounded min-w-125px py-2 px-3 me-5 mb-2">
                                          <div className="d-flex flex-wrap align-items-center">
                                              <span className="svg-icon svg-icon-2 svg-icon-primary me-2">
                                                  <svg
                                                      width="24"
                                                      height="24"
                                                      viewBox="0 0 24 24"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                      <path
                                                          opacity="0.3"
                                                          d="M20.5543 4.37824L12.1798 2.02473C12.0626 1.99176 11.9376 1.99176 11.8203 2.02473L3.44572 4.37824C3.18118 4.45258 3 4.6807 3 4.93945V13.569C3 14.6914 3.48509 15.8404 4.4417 16.984C5.17231 17.8575 6.18314 18.7345 7.446 19.5909C9.56752 21.0295 11.6566 21.912 11.7445 21.9488C11.8258 21.9829 11.9129 22 12.0001 22C12.0872 22 12.1744 21.983 12.2557 21.9488C12.3435 21.912 14.4326 21.0295 16.5541 19.5909C17.8169 18.7345 18.8277 17.8575 19.5584 16.984C20.515 15.8404 21 14.6914 21 13.569V4.93945C21 4.6807 20.8189 4.45258 20.5543 4.37824Z"
                                                          fill="black"
                                                      />
                                                      <path
                                                          d="M12.0006 11.1542C13.1434 11.1542 14.0777 10.22 14.0777 9.0771C14.0777 7.93424 13.1434 7 12.0006 7C10.8577 7 9.92348 7.93424 9.92348 9.0771C9.92348 10.22 10.8577 11.1542 12.0006 11.1542Z"
                                                          fill="black"
                                                      />
                                                      <path
                                                          d="M15.5652 13.814C15.5108 13.6779 15.4382 13.551 15.3566 13.4331C14.9393 12.8163 14.2954 12.4081 13.5697 12.3083C13.479 12.2993 13.3793 12.3174 13.3067 12.3718C12.9257 12.653 12.4722 12.7981 12.0006 12.7981C11.5289 12.7981 11.0754 12.653 10.6944 12.3718C10.6219 12.3174 10.5221 12.2902 10.4314 12.3083C9.70578 12.4081 9.05272 12.8163 8.64456 13.4331C8.56293 13.551 8.49036 13.687 8.43595 13.814C8.40875 13.8684 8.41781 13.9319 8.44502 13.9864C8.51759 14.1133 8.60828 14.2403 8.68991 14.3492C8.81689 14.5215 8.95295 14.6757 9.10715 14.8208C9.23413 14.9478 9.37925 15.0657 9.52439 15.1836C10.2409 15.7188 11.1026 15.9999 11.9915 15.9999C12.8804 15.9999 13.7421 15.7188 14.4586 15.1836C14.6038 15.0748 14.7489 14.9478 14.8759 14.8208C15.021 14.6757 15.1661 14.5215 15.2931 14.3492C15.3838 14.2312 15.4655 14.1133 15.538 13.9864C15.5833 13.9319 15.5924 13.8684 15.5652 13.814Z"
                                                          fill="black"
                                                      />
                                                  </svg>
                                              </span>
                                              <div className="fs-6 fw-bold">{quantityUsers}</div>
                                          </div>
                                          <div className="fw-semibold text-muted">{lang.labels.users}</div>
                                      </div> */}
                                  </div>
                                  {/* <div className="symbol-group symbol-hover">
                                      {company.users &&
                                          company.users.map((item, index) => {
                                              return (
                                                  <div
                                                      key={index}
                                                      className={`symbol symbol-35px symbol-circle + ${index > 3 && "d-none"}`}
                                                      data-bs-toggle="tooltip"
                                                      data-bs-trigger="hover"
                                                      data-bs-original-title={`${item.first_name} ${item.last_name}`}
                                                  >
                                                      {item.avatar && item.avatar.length > 0 ? (
                                                          <img src={item.avatar} alt={lang.labels.avatar} />
                                                      ) : (
                                                          <span className="symbol-label bg-primary text-inverse-primary">
                                                              {item.last_name.charAt(0)}
                                                          </span>
                                                      )}
                                                  </div>
                                              );
                                          })}
                                      {company.users && company.users.length > 1 && (
                                          <div className="symbol symbol-35px symbol-circle" onClick={executeShowModalCompanyView}>
                                              <span
                                                  className="symbol-label bg-dark text-inverse-dark fs-1"
                                                  data-bs-toggle="tooltip"
                                                  data-bs-trigger="hover"
                                                  data-bs-original-title={lang.labels.viewMoreUsers}
                                              >
                                                  +
                                              </span>
                                          </div>
                                      )}
                                  </div> */}
                              </div>
                          </div>
                      </div>
                      {viewNavigationCardCompany() && (
                          <>
                              <div className="separator mb-2"></div>
                              <ul className="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder">
                                  <li className="nav-item">
                                      <a
                                          href="#container-information"
                                          className="nav-link text-active-primary ms-0 me-10 active"
                                          data-bs-toggle="tab"
                                      >
                                          {lang.labels.generalInformation}
                                      </a>
                                  </li>
                                  <li className="nav-item">
                                      <a
                                          href="#container-settings-general"
                                          className="nav-link text-active-primary ms-0 me-10"
                                          data-bs-toggle="tab"
                                      >
                                          {lang.labels.generalSettings}
                                      </a>
                                  </li>
                                  <li className="nav-item">
                                      <a
                                          href="#container-settings-accounting"
                                          className="nav-link text-active-primary ms-0 me-10"
                                          data-bs-toggle="tab"
                                      >
                                          {lang.labels.accountingSettings}
                                      </a>
                                  </li>
                                  <li className="nav-item">
                                      <a
                                          href="#container-settings-download"
                                          className="nav-link text-active-primary ms-0 me-10"
                                          data-bs-toggle="tab"
                                      >
                                          {lang.labels.downloadSettings}
                                      </a>
                                  </li>
                                  {canSub('read', 'digital:payroll:*').allowed && (
                                      <li className="nav-item">
                                          <a
                                              href="#container-settings-salary"
                                              className="nav-link text-active-primary ms-0 me-10"
                                              data-bs-toggle="tab"
                                          >
                                              {lang.labels.salarySettings}
                                          </a>
                                      </li>
                                  )}
                              </ul>
                          </>
                      )}
                  </div>
              </div>
          )}
          <Outlet
              context={{
                  setRoute,
                  appServiceForUser,
                  company,
                  companyForUser,
                  settingsForCompany,
                  designs,
                  reloadSession,
                  loadCompanyForUser,
              }}
          ></Outlet>
          {/* <AppModalCompanyUsers companyForUser={companyForUser}></AppModalCompanyUsers> */}
          {company && <AppModalUuidQr uuid={company.uuid} label={company.name} />}
      </div>
  );
};

export function UseOutletContextCompany() {
  return useOutletContext<ContexType>()
};

export default CompanyPage;
